import { httpService } from "../../../services/httpService.service";

/* Rows for a front-end export.

   The PDF is drawn from data, not from the DOM, so it must not be limited to
   whatever page the table happens to be showing — "export the table" means the
   whole table. getAllSiteVisits already understands IgnorePagination (the
   calendar view uses it), so one request brings back every card in the project
   and the selection export simply keeps the ticked ids out of that set.

   Every status is asked for explicitly: the boards each default to their own
   slice (Planning sends [2, 3]), and an export that silently dropped visits
   that had moved on would be worse than useless. */

const ALL_SITE_VISIT_STATUSES = [2, 3, 4, 5, 6];

export const fetchSiteVisitsForExport = ({ siteVisitIds } = {}) =>
  new Promise((resolve, reject) => {
    const projectId = localStorage.getItem("currentProjectID");

    const params = new URLSearchParams();
    params.append("ProjectId", projectId);
    ALL_SITE_VISIT_STATUSES.forEach((status) =>
      params.append("SiteVisitStatus", status)
    );
    params.append("IgnorePagination", "true");
    params.append("IncludeOnlyWithTracking", "false");

    httpService.get(
      `/api/Site/getAllSiteVisits?${params.toString()}`,
      (response) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
        if (!siteVisitIds?.length) {
          resolve(rows);
          return;
        }
        const wanted = new Set(siteVisitIds.map(String));
        resolve(rows.filter((row) => wanted.has(String(row?.id))));
      },
      (error) => reject(error)
    );
  });

export default fetchSiteVisitsForExport;
